var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"flex"}},[_vm._l((_vm.channelList),function(channel){return [_c('div',{key:channel.value,staticClass:"channel",class:channel.status,staticStyle:{"padding":"2px"}},[_c('em',{class:channel.icon,style:({ color: channel.status == 'active' ? channel.color : '#eee' })})])]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9ea5099c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/intent/AvailableMultipleChannel.vue
// module id = null
// module chunks = 